import React from "react";

const ResultsDisplay = ({pricemessage, medianPrice, transactionCount,medianPricePerSqft,saleToListRatio,averageDOM   }) => {
  return (
    <div>
      {pricemessage && <p className="mt-4 text-red-500">{pricemessage}</p>}
      {transactionCount > 0 && (
        <div className="mt-4">
          <h2 className="text-xl font-bold">Past 60 Days Market Statistics:</h2>
          <p>Median Price: ${medianPrice ? medianPrice.toLocaleString() : "N/A"}</p>
          <p>Transaction Count: {transactionCount}</p>
          <p>Median Price per SQFT: ${medianPricePerSqft}</p>
          <p>Average Sale-to-List Ratio: ${saleToListRatio.toFixed(2)}%</p>
          <p >Average Days on Market: {averageDOM.toFixed(2)} days</p>
        </div>
      )}
    </div>
  );
};

export default ResultsDisplay;
